// kalkMatica.js — model jednoduchej kalkulačnej matice (Mirko 24.7.2026).
// Riadky = nákladové položky (ľavý stĺpec), stĺpce = produkty. Bunka = €/m², PRESNE to čo Mirko napíše.
// ŽIADNA skrytá matematika: automatická +5 % rezerva na materiál sa v matici NEPOUŽÍVA (Mirkovo rozhodnutie 24.7.).
// Starý tvar (data.polozky) sa NIKDY nemaže ani nekonvertuje — staré kalkulácie sa otvárajú po starom.

export const uid = () => Math.random().toString(36).slice(2, 9)

// Ľavý stĺpec — presne Mirkova tabuľka. Poradie poľa = poradie riadkov.
export const DEFAULT_ROWS = [
  ['robota', 'Robota', 'm²'],
  ['material', 'Materiál', ''],
  ['rohovnik', 'Rohovník', '50 ks / 400 m²'],
  ['apu', 'APU lišta', '50 ks / 400 m²'],
  ['rotor', 'Rotor-stator', '1 pár / 1000 m²'],
  ['pasky', 'Pásky', '15 € / 200 m²'],
  ['folie', 'Fólie', '10 € / 200 m²'],
  ['penetr', 'Penetrácia / BetónKontakt', '19 € / 70 m²'],
  ['sietka', 'Sieťka', '23 € / 300 m²'],
  ['prevoz', 'Prevoz', '2228 € / stavba'],
  ['majster', 'Majster', 'odhad'],
  ['servis', 'Servis', '100 € / 2000 m²'],
  ['smetie', 'Smetie', '260 € / 1500 m²'],
  ['zriadenie', 'Zriadenie staveniska', '1,5 %'],
  ['nepr', 'Nepredvídané výdavky', '1500 € / stavba'],
  ['ubytko', 'Ubytko', ''],
  ['rezia', 'Réžia firmy', ''],
  ['upratovac', 'Upratovač', '125 € / týž. × 12 týž.'],
].map(([id, l, prepocet]) => ({ id, l, prepocet }))

export const freshRow = (l) => ({ id: 'r_' + uid(), l: l || 'Nová položka', prepocet: '' })
export const freshCol = (l) => ({ id: 'c_' + uid(), l: l || 'Nový produkt', kg: '', vymera: '', predajna: '', v: {} })
export const freshMatica = () => ({ rows: DEFAULT_ROWS.map(r => ({ ...r })), cols: [freshCol('Produkt 1')] })

// Rozlíšenie tvaru — nový (matica) vs starý (polozky). Lacné a jednoznačné.
export const isMatica = (d) => !!(d && d.matica && Array.isArray(d.matica.cols))

const n = (x) => { const v = Number(String(x == null ? '' : x).replace(',', '.')); return isFinite(v) ? v : 0 }

// Súčet stĺpca = jednotková cena na m². Iteruje cez ROWS, nie cez kľúče v — osirelé kľúče sa nikdy nezapočítajú.
export const colNaklad = (col, rows) => (rows || []).reduce((a, r) => a + n((col.v || {})[r.id]), 0)

export const colStats = (col, rows) => {
  const naklad = colNaklad(col, rows)
  const predajna = n(col.predajna)
  const vymera = n(col.vymera)
  const zisk = predajna - naklad
  return {
    naklad, predajna, vymera, zisk,
    nakladCena: naklad * vymera,
    trzba: predajna * vymera,
    ziskSpolu: zisk * vymera,
  }
}

export const sumMatica = (matica) => {
  const rows = (matica && matica.rows) || []
  return ((matica && matica.cols) || []).reduce((a, c) => {
    const s = colStats(c, rows)
    return { n: a.n + s.nakladCena, t: a.t + s.trzba, z: a.z + s.ziskSpolu }
  }, { n: 0, t: 0, z: 0 })
}

// Jednotný súčet pre zoznam/KPI — vetví podľa tvaru. legacySum = pôvodná sumKalk z KalkulacieView.
export const sumKalkAny = (record, legacySum) => {
  const d = (record && record.data) || {}
  if (isMatica(d)) return sumMatica(d.matica)
  return legacySum ? legacySum(record) : { n: 0, t: 0, z: 0 }
}

// Názov stavby do ľavého zoznamu — reťaz fallbackov (project_id je dnes prázdny, preto denormalizované polia).
export const stavbaNazov = (r) => {
  const d = (r && r.data) || {}
  return (r && r.stavba_name) || d.stavba_nazov || d.dopyt_nazov || ''
}
